import script from "./Spinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./Spinner.vue?vue&type=script&lang=ts&setup=true"

import "./Spinner.vue?vue&type=style&index=0&id=728962ae&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728962ae"]])

export default __exports__